import { Component } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-check',
  templateUrl: './app-check.component.html',
})
export class AppCheckComponent extends FieldComponent {

}
